"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectTagForm = exports.SelectTag = exports.SelectGroup = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDeviceDetect = require("react-device-detect");

var _selectInputNative = _interopRequireDefault(require("./select-input-native"));

var _inputTitle = _interopRequireDefault(require("../ClassiInput/input-title"));

var _inputStyles = require("../ClassiInput/input-styles");

var _selectStyles = require("./select-styles");

var _selectGroupInput = require("./select-group-input");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var defaultGetLabel = function defaultGetLabel(item) {
  return item.descricao;
};

var defaultGetValue = function defaultGetValue(item) {
  return item.id;
};

var SelectTag = function SelectTag(_ref) {
  var id = _ref.id,
      value = _ref.value,
      title = _ref.title,
      name = _ref.name,
      error = _ref.error,
      subtitle = _ref.subtitle,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      disabled = _ref.disabled,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? "" : _ref$placeholder,
      onChange = _ref.onChange,
      height = _ref.height,
      _ref$multiSelection = _ref.multiSelection,
      multiSelection = _ref$multiSelection === void 0 ? false : _ref$multiSelection,
      setMultiValue = _ref.setMultiValue,
      isSearchable = _ref.isSearchable,
      menuPosition = _ref.menuPosition,
      required = _ref.required,
      onRemoveTag = _ref.onRemoveTag,
      _ref$customStyle = _ref.customStyle,
      customStyle = _ref$customStyle === void 0 ? {} : _ref$customStyle,
      _ref$getOptionLabel = _ref.getOptionLabel,
      getOptionLabel = _ref$getOptionLabel === void 0 ? defaultGetLabel : _ref$getOptionLabel,
      _ref$getOptionValue = _ref.getOptionValue,
      getOptionValue = _ref$getOptionValue === void 0 ? defaultGetValue : _ref$getOptionValue;

  var handleRemoveTag = function handleRemoveTag(e, removedOption) {
    if (onRemoveTag) {
      onRemoveTag(e, removedOption);
    }
  };

  var optionSelected = function optionSelected(selectedOption) {
    if (multiSelection && setMultiValue) {
      setMultiValue(selectedOption);
    } else if (onChange) {
      onChange(selectedOption);
    }
  };

  return /*#__PURE__*/_react.default.createElement(_selectStyles.Container, null, /*#__PURE__*/_react.default.createElement("label", null, /*#__PURE__*/_react.default.createElement(_inputTitle.default, {
    title: title,
    subtitle: subtitle,
    required: required,
    error: error
  }), _reactDeviceDetect.isMobile ? /*#__PURE__*/_react.default.createElement(_selectInputNative.default, {
    options: options,
    value: value,
    placeholder: placeholder,
    multiSelection: multiSelection,
    getOptionLabel: getOptionLabel,
    getOptionValue: getOptionValue,
    optionSelected: optionSelected
  }) : /*#__PURE__*/_react.default.createElement(_selectStyles.SelectInput, {
    value: multiSelection ? null : value,
    isSearchable: isSearchable,
    isDisabled: disabled,
    instanceId: "".concat(name, "-").concat(id),
    height: height,
    menuPosition: menuPosition,
    style: customStyle,
    options: options,
    placeholder: placeholder,
    error: error,
    getOptionLabel: getOptionLabel,
    getOptionValue: getOptionValue,
    onChange: optionSelected,
    noOptionsMessage: function noOptionsMessage() {
      return "Nenhum resultado encontrado";
    }
  })), multiSelection && /*#__PURE__*/_react.default.createElement(_selectStyles.TagContainer, null, value instanceof Array && value.map(function (item) {
    return /*#__PURE__*/_react.default.createElement(_selectStyles.TagItem, {
      key: getOptionValue(item),
      "ariel-label": "Remover tag ".concat(getOptionLabel(item)),
      onClick: function onClick(e) {
        return handleRemoveTag(e, getOptionValue(item));
      }
    }, /*#__PURE__*/_react.default.createElement("span", null, getOptionLabel(item)), /*#__PURE__*/_react.default.createElement(_selectStyles.RemoveTag, null));
  })));
};

exports.SelectTag = SelectTag;

var SelectTagForm = function SelectTagForm(_ref2) {
  var id = _ref2.id,
      input = _ref2.input,
      title = _ref2.title,
      subtitle = _ref2.subtitle,
      options = _ref2.options,
      disabled = _ref2.disabled,
      _ref2$placeholder = _ref2.placeholder,
      placeholder = _ref2$placeholder === void 0 ? "" : _ref2$placeholder,
      _ref2$multiSelection = _ref2.multiSelection,
      multiSelection = _ref2$multiSelection === void 0 ? false : _ref2$multiSelection,
      isSearchable = _ref2.isSearchable,
      height = _ref2.height,
      menuPosition = _ref2.menuPosition,
      customStyle = _ref2.customStyle,
      containerstyle = _ref2.containerstyle,
      getOptionLabel = _ref2.getOptionLabel,
      getOptionValue = _ref2.getOptionValue,
      onChange = _ref2.onChange,
      meta = _ref2.meta,
      isrequired = _ref2.isrequired;
  var error = meta.error && meta.touched;

  var handleChange = function handleChange(selectedOption) {
    if (onChange) {
      onChange(selectedOption);
    }

    input.onChange(selectedOption);
  };

  var setMultiValue = function setMultiValue(selectedOption) {
    var getValue = getOptionValue ? getOptionValue : defaultGetValue;
    var values = input.value || [];
    var alreadySelected = values.some(function (item) {
      return getValue(item) === getValue(selectedOption);
    });

    if (!alreadySelected) {
      input.onChange([].concat(_toConsumableArray(input.value), [selectedOption]));
    }
  };

  var removeTag = function removeTag(e, removedOption) {
    var getValue = getOptionValue ? getOptionValue : defaultGetValue;
    input.onChange(input.value.filter(function (item) {
      return getValue(item) !== removedOption;
    }));
    e.preventDefault();
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    style: _objectSpread({
      display: "flex",
      flexDirection: "column"
    }, containerstyle)
  }, /*#__PURE__*/_react.default.createElement(SelectTag, {
    id: id,
    value: input.value,
    title: title,
    name: input.name,
    error: error,
    required: isrequired,
    disabled: disabled,
    isSearchable: isSearchable,
    height: height,
    menuPosition: menuPosition,
    containerstyle: {
      flex: 1
    },
    subtitle: subtitle,
    options: options ? options : [],
    placeholder: placeholder,
    multiSelection: multiSelection,
    getOptionLabel: getOptionLabel ? getOptionLabel : defaultGetLabel,
    getOptionValue: getOptionValue ? getOptionValue : defaultGetValue,
    customStyle: customStyle,
    onChange: handleChange,
    setMultiValue: setMultiValue,
    onRemoveTag: removeTag
  }), error && /*#__PURE__*/_react.default.createElement(_inputStyles.Erro, null, meta.error));
};

exports.SelectTagForm = SelectTagForm;
SelectTagForm.prototype = {
  id: _propTypes.default.string,
  title: _propTypes.default.string,
  subtitle: _propTypes.default.string,
  isrequired: _propTypes.default.bool,
  error: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  placeholder: _propTypes.default.string,
  isSearchable: _propTypes.default.bool,
  options: _propTypes.default.array,
  getOptionLabel: _propTypes.default.func,
  getOptionValue: _propTypes.default.func,
  onChange: _propTypes.default.func,
  input: _propTypes.default.object,
  meta: _propTypes.default.object,
  containerstyle: _propTypes.default.object,
  inputwrapperstyle: _propTypes.default.object
};
SelectTagForm.defaultProps = {
  id: "1",
  title: "Combo",
  subtitle: "",
  isrequired: false,
  error: false,
  disabled: false,
  placeholder: "Escolha uma opção",
  isSearchable: false,
  options: [],
  getOptionLabel: function getOptionLabel(item) {
    return item === null || item === void 0 ? void 0 : item.descricao;
  },
  getOptionValue: function getOptionValue(item) {
    return item === null || item === void 0 ? void 0 : item.id;
  },
  onChange: function onChange() {},
  input: {},
  meta: {},
  containerstyle: {},
  inputwrapperstyle: {}
};

var SelectGroup = function SelectGroup(_ref3) {
  var name = _ref3.name,
      value = _ref3.value,
      title = _ref3.title,
      subtitle = _ref3.subtitle,
      placeholder = _ref3.placeholder,
      options = _ref3.options,
      onChange = _ref3.onChange,
      input = _ref3.input,
      isrequired = _ref3.isrequired,
      disabled = _ref3.disabled,
      multiSelection = _ref3.multiSelection,
      meta = _ref3.meta;
  var error = meta.error && meta.touched;

  var handleChange = function handleChange(selectedOption) {
    if (onChange) {
      onChange(selectedOption);
    }

    input.onChange(selectedOption);
  };

  var formatGroupLabel = function formatGroupLabel(data) {
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between"
      }
    }, /*#__PURE__*/_react.default.createElement("span", null, data.descricao), /*#__PURE__*/_react.default.createElement("span", null, data.options.length));
  };

  return /*#__PURE__*/_react.default.createElement(_selectStyles.Container, null, /*#__PURE__*/_react.default.createElement(_inputTitle.default, {
    title: title,
    subtitle: subtitle,
    required: isrequired
  }), /*#__PURE__*/_react.default.createElement(_selectGroupInput.SelectGroupInput, {
    name: name,
    title: title,
    placeholder: placeholder,
    options: options,
    error: error,
    value: value,
    required: isrequired,
    disabled: disabled,
    multiSelection: multiSelection,
    containerstyle: {
      flex: 1
    },
    formatGroupLabel: formatGroupLabel,
    onChange: handleChange
  }), error && /*#__PURE__*/_react.default.createElement(_inputStyles.Erro, null, meta.error));
};

exports.SelectGroup = SelectGroup;